import React from "react";
import { Button } from "react-bootstrap";
import classes from "./CustomButtonBlueBg.module.css";

const CustomButtonBlueBg = (props) => {
  return (
    <Button 
        className={classes.buttonStyle} 
        onClick={props.handleClick}>
        {props.children}
    </Button>
    );
};

export default CustomButtonBlueBg;